var _path, _path2, _path3;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgPrice = function SvgPrice(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    viewBox: "0 0 32 32",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D8D8D8",
    d: "M0 0H32V32H0z",
    opacity: 0.01
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#A7D9FF",
    d: "M12.762 10.999c-.988 0-1.789.801-1.789 1.79 0 .988.801 1.789 1.79 1.789.988 0 1.789-.802 1.789-1.79v-.026c0-.974-.79-1.763-1.763-1.763h-.027zm-4-2.237c.198-.19.463-.295.737-.29l6.579-.183c.433-.003.85.168 1.157.473l8.29 8.289c.617.595.635 1.577.04 2.195l-.04.042-6.237 6.236c-.595.617-1.578.636-2.195.041l-.042-.041-8.288-8.289c-.306-.308-.476-.724-.474-1.158L8.473 9.5c-.006-.274.099-.54.29-.737z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#579FD7",
    d: "M11.5 12.026c-.14-.002-.272-.059-.369-.158L6.105 6.842c-.174-.233-.127-.562.106-.737.187-.14.444-.14.631 0l5.026 5.026c.203.187.217.503.03.706l-.03.03c-.097.1-.23.157-.369.159zM23.024 17.867l-5.157 5.157-4.447-4.473 5.131-5.131 4.473 4.447z"
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPrice, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/price.2da10c50.svg";
export { ForwardRef as ReactComponent };